import { Loader2 } from "lucide-react"
import { ButtonProps } from "../../../../types"
import { cn } from "../../../utils"

const paddingClassName: Record<NonNullable<ButtonProps["size"]>, string> = {
  sm: "py-1 px-2",
  base: "py-3 px-4",
  md: "py-4 px-6",
  lg: "py-6 px-8"
}

const textClassName: Record<NonNullable<ButtonProps["text"]>, string> = {
  sm: "text-sm",
  base: "text-base",
  md: "text-md",
  lg: "text-lg"
}

const Button = ({
  icon,
  iconPosition = "left",
  children,
  className = "",
  type = "button",
  disabled = false,
  paddingOff = false,
  onClick,
  onKeyDown,
  href,
  target = "_blank",
  refProp,
  text = "sm",
  size = "base",
  isLoading = false,
  title,
  tabIndex = -1
}: ButtonProps) => {
  const Icon = icon
  const cls = cn(
    disabled ? "text-gray-400 pointer-events-none cursor-not-allowed" : "",
    "transition-colors relative inline-flex justify-center items-center border font-medium rounded-md focus:outline-none",
    textClassName[text],
    paddingOff ? "p-0" : paddingClassName[size],
    isLoading ? "pointer-events-none cursor-pointer" : "",
    className
  )

  const renderInner = () => (
    <>
      {isLoading && <Loader2 className="animate-spin h-5 w-5 mr-2" />}
      {Icon && iconPosition === "left" && (
        <span className="mr-2">
          <Icon className="h-5 w-5" />
        </span>
      )}
      {children}
      {Icon && iconPosition === "right" && (
        <span className="ml-2">
          <Icon className="h-5 w-5" />
        </span>
      )}
    </>
  )

  return href ? (
    <a
      href={href}
      className={cls}
      target={target}
      title={title}
      onKeyDown={onKeyDown}
      tabIndex={tabIndex}
    >
      {renderInner()}
    </a>
  ) : (
    <button
      title={title}
      tabIndex={tabIndex}
      ref={refProp}
      disabled={disabled}
      type={type}
      className={cls}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      {renderInner()}
    </button>
  )
}

export default Button
